import React from "react";
import VerificationForm from "../../components/Verification/VerificationForm";

const VerificationCode = () => {
  return <VerificationForm />;
};

export default VerificationCode;
